export default "__VITE_ASSET__7fiFMU5W__"